// LUMINA · pages/vajra/ActivityPage.jsx
// Phase 59D: 事业法门 — list all four activities + per-activity detail
// Routes: /vajra/activities (list) · /vajra/activities/:id (detail)

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API, GD, GDL, BG, TXT, TXT2 } from './constants';
import { FOUR_ACTIVITIES } from '../../constants/dharmaActivities';

function DeityCard({ deity, userCredKeys }) {
  const locked = deity.credential_key && !userCredKeys.has(deity.credential_key);
  const loggedIn = !!localStorage.getItem("vajra_token");

  return (
    <div style={{
      padding: "16px 18px", borderRadius: 10,
      background: "#fff",
      border: `1px solid rgba(212,175,55,0.15)`,
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      marginBottom: 10,
    }}>
      <div style={{ fontSize: 15, color: GD, fontWeight: 600, marginBottom: 4 }}>
        {deity.name_zh}
        {deity.name_en && (
          <span style={{ fontSize: 10, color: TXT2, marginLeft: 8, opacity: 0.6 }}>
            {deity.name_en}
          </span>
        )}
      </div>
      <div style={{ fontSize: 12, color: TXT2, lineHeight: 1.6, marginBottom: 10 }}>
        {deity.description}
      </div>
      {deity.credential_key && (
        <div style={{
          fontSize: 11, padding: "4px 10px", borderRadius: 20, display: "inline-block",
          background: locked
            ? (loggedIn ? "rgba(239,68,68,0.08)" : "rgba(107,79,59,0.08)")
            : "rgba(16,185,129,0.08)",
          color: locked
            ? (loggedIn ? "#dc2626" : TXT2)
            : "#065f46",
          border: locked
            ? (loggedIn ? "1px solid rgba(239,68,68,0.2)" : `1px solid rgba(139,105,20,0.2)`)
            : "1px solid rgba(16,185,129,0.2)",
        }}>
          {!loggedIn
            ? "🔒 登录后查看修法详情"
            : locked
            ? `🔑 需要灌顶: ${deity.credential_key}`
            : "✅ 可查看修法 →"}
        </div>
      )}
    </div>
  );
}

function ActivityCard({ activity, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        padding: "20px 22px", borderRadius: 12, cursor: "pointer",
        background: activity.bg,
        border: `1.5px solid ${activity.border}`,
        marginBottom: 14,
        transition: "box-shadow .15s, transform .15s",
      }}
      onMouseOver={e => {
        e.currentTarget.style.boxShadow = `0 6px 20px ${activity.border}`;
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={e => {
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.transform = "none";
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
        <span style={{ fontSize: 28 }}>{activity.emoji}</span>
        <div>
          <div style={{ fontSize: 17, color: activity.color, fontWeight: 600 }}>
            {activity.name_zh}
          </div>
          <div style={{ fontSize: 10, color: TXT2, opacity: 0.7 }}>{activity.name_en}</div>
        </div>
      </div>
      <div style={{ fontSize: 12, color: TXT2, lineHeight: 1.6 }}>{activity.description}</div>
      <div style={{ marginTop: 10, fontSize: 11, color: activity.color, opacity: 0.8 }}>
        {activity.deities.map(d => d.name_zh).join(" · ")} →
      </div>
    </div>
  );
}

export default function ActivityPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [userCredKeys, setUserCredKeys] = useState(new Set());

  useEffect(() => {
    const token = localStorage.getItem("vajra_token");
    if (!token) return;
    fetch(`${API}/vajra/me/initiations`, {
      headers: { "Authorization": `Bearer ${token}` }
    })
      .then(r => r.ok ? r.json() : [])
      .then(d => {
        if (Array.isArray(d)) {
          setUserCredKeys(new Set(d.map(c => c.credential_key).filter(Boolean)));
        }
      })
      .catch(() => {});
  }, []);

  // ── Detail page ─────────────────────────────────────────────────────────────
  if (id) {
    const activity = FOUR_ACTIVITIES.find(a => a.id === id);
    if (!activity) return (
      <div style={{ minHeight: "100vh", background: BG, display: "flex", alignItems: "center",
        justifyContent: "center", color: TXT2, fontFamily: "'Noto Serif SC',serif" }}>
        未找到此事业法
      </div>
    );

    return (
      <div style={{ minHeight: "100vh", background: BG,
        fontFamily: "'Noto Serif SC',serif", color: TXT }}>
        <div style={{
          position: "sticky", top: 0, zIndex: 100,
          background: "rgba(253,251,247,0.95)", backdropFilter: "blur(16px)",
          borderBottom: `1px solid rgba(212,175,55,0.2)`,
          padding: "0 24px", height: 52,
          display: "flex", alignItems: "center", gap: 12,
        }}>
          <a href="/vajra/activities" style={{
            background: "none", border: "none", color: GD, cursor: "pointer", fontSize: 13, textDecoration: "none",
          }}>如意宝金刚社群</a>
          <span style={{ fontSize: 20 }}>{activity.emoji}</span>
          <span style={{ color: activity.color, fontSize: 15, fontWeight: 600 }}>
            {activity.name_zh}
          </span>
        </div>

        <div style={{ maxWidth: 700, margin: "0 auto", padding: "32px 24px 80px" }}>
          <div style={{
            background: activity.bg, border: `1.5px solid ${activity.border}`,
            borderRadius: 14, padding: "24px",
            marginBottom: 28,
          }}>
            <div style={{ fontSize: 13, color: TXT2, lineHeight: 1.8 }}>{activity.detail}</div>
          </div>

          <div style={{ fontSize: 13, color: GD, letterSpacing: 2, marginBottom: 16 }}>主要本尊</div>
          {activity.deities.map(deity => (
            <DeityCard key={deity.name_zh} deity={deity} userCredKeys={userCredKeys} />
          ))}

          <div style={{ marginTop: 28, textAlign: "center" }}>
            <button onClick={() => navigate("/vajra/shop")} style={{
              background: "none", border: `1px solid rgba(139,105,20,0.3)`,
              borderRadius: 8, color: GD, fontSize: 12, padding: "8px 24px",
              cursor: "pointer", letterSpacing: 1,
            }}>
              查看相关法宝流通 →
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── List page ────────────────────────────────────────────────────────────────
  return (
    <div style={{ minHeight: "100vh", background: BG,
      fontFamily: "'Noto Serif SC',serif", color: TXT }}>
      <div style={{
        position: "sticky", top: 0, zIndex: 100,
        background: "rgba(253,251,247,0.95)", backdropFilter: "blur(16px)",
        borderBottom: `1px solid rgba(212,175,55,0.2)`,
        padding: "0 24px", height: 52,
        display: "flex", alignItems: "center", gap: 12,
      }}>
        <a href="/vajra" style={{
          background: "none", border: "none", color: GD, cursor: "pointer", fontSize: 13, textDecoration: "none",
        }}>如意宝金刚社群</a>
        <span style={{ color: GD, fontSize: 15, fontWeight: 600 }}>四大事业法门</span>
      </div>

      <div style={{ maxWidth: 700, margin: "0 auto", padding: "32px 24px 80px" }}>
        <div style={{ fontSize: 12, color: TXT2, lineHeight: 1.8, marginBottom: 28 }}>
          四大事业法（息增怀诛）是藏传佛法中解决现实生活问题的实用法门，
          适合所有修行层次——公开介绍层无需灌顶，具体修法视传承资质而定。
        </div>
        {FOUR_ACTIVITIES.map(activity => (
          <ActivityCard
            key={activity.id}
            activity={activity}
            onClick={() => navigate(`/vajra/activities/${activity.id}`)}
          />
        ))}
      </div>
    </div>
  );
}
